exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:768px){.app-modal{overflow-y:auto!important}}.tall-modal{overflow-y:auto!important}", ""]);

// exports
